import { jsx as _jsx } from "react/jsx-runtime";
import { resolveCssVariable } from '@prophecy/theme';
import styled from 'styled-components';
import { IconSize } from './Icon';
import { LOGO_ICON_CLASS, tokens as iconTokens } from './tokens';
export const withLogoClass = (WrappedComponent) => {
    return (props) => {
        const iconSize = resolveCssVariable(iconTokens.Icon[props.size || IconSize.m].size);
        return (_jsx(WrappedComponent, { ...props, className: `${LOGO_ICON_CLASS} ${props.className || ''}`, width: props.width || iconSize, height: props.height || iconSize }));
    };
};
export const withLogoClassAndGrayscale = (WrappedComponent) => {
    return styled((props) => {
        const iconSize = resolveCssVariable(iconTokens.Icon[props.size || IconSize.m].size);
        return (_jsx(WrappedComponent, { ...props, className: `${LOGO_ICON_CLASS} \${props.className || ""}`, width: props.width || iconSize, height: props.height || iconSize }));
    }) `
    filter: grayscale(1);
  `;
};
